export const formatEventWhen = (startsAt?: string | null, endsAt?: string | null) => {
  if (!startsAt) return 'Date to be announced';
  const start = new Date(startsAt);
  const startLabel = start.toLocaleString(undefined, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
  if (!endsAt) return startLabel;
  const end = new Date(endsAt);
  return `${startLabel} – ${end.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })}`;
};

export const speakerHeadline = (event: {
  speakerName?: string | null;
  speakerTitle?: string | null;
  speakerCompany?: string | null;
}) => {
  if (!event.speakerName) return null;
  const role = [event.speakerTitle, event.speakerCompany].filter(Boolean).join(', ');
  return role ? `${event.speakerName} · ${role}` : event.speakerName;
};
